export default {
	passwordReset: '/users/password/reset',
	passwordUpdate: '/users/password/update',
	create: '/users/create',
	userById: (id: string) => `/users/${id}`,
	collaborators: '/users/collaborators',
	me: '/users/me',
	subLabels: '/users/me/sub-labels',
	subLabelById: (labelId: number) => `/users/me/sub-labels/${labelId}`,
	myProfiles: '/users/me/profiles',
	settings: '/users/me/settings',
};
